import React from 'react'
import { motion } from 'framer-motion'

export default function OportunidadesLayout({
  left,
  children,
}: {
  left?: React.ReactNode
  children: React.ReactNode
}) {
  const hasLeft = !!left
  // Painel toggle desabilitado; se não houver 'left', renderiza apenas a coluna principal.
  const open = true

  if (!hasLeft) {
    return (
      <div className="flex w-full flex-col gap-3">
        <div className="min-w-0 flex-1">{children}</div>
      </div>
    )
  }

  return (
    <div className="flex w-full flex-col gap-3">
      {/* Botão de expandir/ocultar desabilitado por hora */}
      <div className="flex w-full items-stretch gap-4">
        <motion.div
          aria-hidden={!open}
          initial={false}
          animate={{ width: open ? 320 : 0, opacity: open ? 1 : 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          className="overflow-hidden rounded-lg"
        >
          <div className="p-3">{left}</div>
        </motion.div>
        <div className="min-w-0 flex-1">{children}</div>
      </div>
    </div>
  )
}
